import React from 'react';
import PropTypes from 'prop-types';
import {
  ModalContentComponent,
  ModalHeader,
  Line,
  Icon,
  Heading,
  Body,
  ButtonCTA,
} from './ModalContent.styles.js';
import { ReactHtmlParser } from 'helpers/utilities.js';

const ModalContent = ({ icon, title, children, buttonText, buttonAction = () => {}, brand, dark = true }) => {
  return (
    <ModalContentComponent>
      <ModalHeader>
        <Line></Line>
        <Icon src={icon} />
        <Line></Line>
      </ModalHeader>
      <Heading>{ReactHtmlParser(title)}</Heading>
      {children ? <Body>{children}</Body> : null}
      {buttonText ? (
        <ButtonCTA onClick={buttonAction} dark={dark} brand={brand}>
          {ReactHtmlParser(buttonText)}
        </ButtonCTA>
      ) : null}
    </ModalContentComponent>
  );
};

ModalContent.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  buttonText: PropTypes.string,
  buttonAction: PropTypes.func,
  brand: PropTypes.string,
  dark: PropTypes.bool,
};

export default ModalContent;
